import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Appointment } from './appointment.js';
import { readEntitiesByIDs } from '../server/entity-reads.js';
import { Workshop } from './workshop.js';

@Entity()
export class WorkshopAppointmentParticipationConfirmationLink extends AdornisEntity {
  static override _class = 'WorkshopAppointmentParticipationConfirmationLink';

  @validate(nonOptional())
  @Field(type => String)
  workshopID!: string;

  @validate(nonOptional())
  @Field(type => String)
  appointmentID!: string;

  @Field(type => Appointment, {
    resolve: function (this: WorkshopAppointmentParticipationConfirmationLink) {
      return async (gqlFields: BaseQLSelectionSet<Appointment>) => {
        const [workshop] = await readEntitiesByIDs(Workshop, [this.workshopID], { appointments: gqlFields });
        return workshop?.appointments?.find(ap => ap._id === this.appointmentID) as any;
      };
    },
  })
  appointment!: Appointment;

  @validate(nonOptional())
  @Field(type => Date, { default: v => v ?? new Date() })
  validFrom: Maybe<Date>;

  @validate(nonOptional())
  @Field(type => Date)
  validTill: Maybe<Date>;

  @validate(nonOptional())
  @Field(type => String)
  url!: string;
}
